import { render, staticRenderFns } from "./CardSP.vue?vue&type=template&id=213b9424&scoped=true"
import script from "./CardSP.vue?vue&type=script&lang=js"
export * from "./CardSP.vue?vue&type=script&lang=js"
import style0 from "./CardSP.vue?vue&type=style&index=0&id=213b9424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213b9424",
  null
  
)

export default component.exports